import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

// ============================================
// IMPORT YOUR 6 IRRIGATION TUNNEL IMAGES HERE ⬇️
// ============================================
import irri1 from '../assets/images/irri1.jpg';
import irri2 from '../assets/images/irri2.jpg';
import irri3 from '../assets/images/irri3.jpg';
import irri4 from '../assets/images/irri4.jpg';
import irri5 from '../assets/images/irri5.jpg';
import irri6 from '../assets/images/irri6.jpg';

import '../styles/Pages.css';

const IrrigationTunnel = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // All 6 images array
  const images = [irri1, irri2, irri3, irri4, irri5, irri6];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Irrigation Tunnel</h1>
            <p>Water Management Infrastructure Solutions</p>
          </div>
        </div>
      </section>

      {/* IMAGES SECTION - 6 IMAGES IN 3-COLUMN GRID */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          {/* HEADING */}
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '50px', 
            textAlign: 'center' 
          }}>
            Irrigation Tunnel Projects
          </h2>

          {/* IMAGES GRID - 3 COLUMNS (2 ROWS) */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '30px',
            marginTop: '40px',
            maxWidth: '1200px',
            margin: '40px auto 0'
          }}>
            {images.map((img, index) => (
              <div 
                key={index}
                style={{ 
                  overflow: 'hidden', 
                  borderRadius: '8px', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.12)', 
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  aspectRatio: '1'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
                }}
              >
                <img 
                  src={img} 
                  alt={`Irrigation Tunnel ${index + 1}`}
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    display: 'block',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEXT SECTION AT BOTTOM */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '30px', 
            textAlign: 'center' 
          }}>
            Our Tunnelling Expertise
          </h2>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8', 
            marginBottom: '20px',
            textAlign: 'justify'
          }}>
            Max Infra's expertise lies in Tunnelling. So far we have successfully completed two Railway Tunnels in challenging locations, Shear Zones and difficult terrains. At present we are executing six Railway Tunnels in different locations.
          </p>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8',
            textAlign: 'justify'
          }}>
            Our experienced team, advanced machinery, and proven track record in tunnelling demonstrate our commitment to delivering world-class infrastructure solutions even in the most challenging geological conditions.
          </p>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE DESIGN */}
      <style>{`
        @media (max-width: 1024px) {
          .irri-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 25px !important;
          }
        }
        @media (max-width: 768px) {
          .irri-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default IrrigationTunnel;